mutation updateCompanyContactPerson($input: UpdateCompanyContactPersonInput!) {
  contactPerson: updateCompanyContactPerson(input: $input) {
    id
    type
    companyName
    salutation
    firstname
    lastname
    role
    email
    phone
    mobile
    note
    address {
      street
      city
      zip
      country
    }
  }
}
